import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	() =>
		createStyles({
			rootPage: {
				position: "relative",
				height: "100vh"
			}
		}),
	{
		name: "PageContainer",
		index: 1
	}
);

export default useStyles;
